import { SharedState } from '@trello/shared-state';

export const boardSidebarState = new SharedState(false);
